import React, { useEffect, useState } from "react";
import {
  getDemoRequest,
  DemoRequestResponse,
} from "../../services/dashboard/DemoRequest";

import { useNavigate } from "react-router-dom";
import "../../styles/dash/DemoRequestTable.css";
import LoadingSpinner from "../utility/LoadingSpinner";

// Interfaces para los permisos
interface Permission {
  Id: number;
  IdAction: number;
  Action: string;
  IdModule: number;
  ModuleName: string;
}

interface Role {
  Id: number;
  RoleName: string;
  Permissions: Permission[];
}

const DemoRequestTable: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<DemoRequestResponse[]>([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState("2025-12-31");

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getDemoRequest(startDate, endDate, page);
      setData(response.data);
      setTotalRecords(response.totalRecords);
    } catch (err) {
      console.error("Error al obtener las solicitudes:", err);
      setError("Error al obtener las solicitudes");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let hasPermission = false;
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const userObject = JSON.parse(userData);
        const userDataParsed = JSON.parse(userObject.userData || "{}");

        if (userDataParsed?.roles?.length) {
          const permisosAplanados = userDataParsed.roles.flatMap((rol: Role) =>
            rol.Permissions.map((p: Permission) => p.IdAction)
          );
          if (permisosAplanados.includes(32)) {
            hasPermission = true;
          }
        }
      } catch (err) {
        console.error('Error parsing user data:', err);
      }
    }
    if (!hasPermission) {
      navigate("/login");
    } else {
      fetchData();
    }
  }, [page, navigate]);

  const totalPages = Math.ceil(totalRecords / 10);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className="demo-request-table-container">
      {/* Filtros */}
      <div className="filter-controls">
        <label>
          Fecha inicio:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          Fecha fin:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
        <button
          onClick={() => {
            setPage(1);
            fetchData();
          }}
        >
          Filtrar
        </button>
      </div>

      {/* Tabla */}
      <table className="demo-request-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th>Teléfono</th>
            <th>Compañía</th>
            <th>Cargo</th>
            <th>Industria</th>
            <th>Tamaño</th>
            <th>Consultas mensuales</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>{item.fullName}</td>
              <td>{item.corporateEmail}</td>
              <td>{item.phone}</td>
              <td>{item.companyName}</td>
              <td>{item.jobTitle}</td>
              <td>{item.industry}</td>
              <td>{item.companySize}</td>
              <td>{item.monthlyCustomerQueries}</td>
              <td>{new Date(item.requestDate).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      <div className="pagination-controls">
        <button
          disabled={page === 1}
          onClick={() => setPage((prev) => Math.max(1, prev - 1))}
        >
          Anterior
        </button>
        <span>
          Página {page} de {totalPages}
        </span>
        <button
          disabled={page === totalPages}
          onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default DemoRequestTable;
